<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-flag heroicon heroicon-sm"
  >
    <rect
      class="heroicon-flag-pole heroicon-component-fill"
      width="3"
      height="53"
      x="3"
      y="6"
      fill="#FFFFFF"
    ></rect>
    <circle
      class="heroicon-flag-pole-top heroicon-component-accent heroicon-component-fill"
      cx="4.5"
      cy="3.5"
      r="3.5"
      fill="#7ACFC0"
    ></circle>
    <path
      class="heroicon-flag-background heroicon-component-fill"
      fill="#FFFFFF"
      d="M36 16v-6a2 2 0 0 0-2-2H6v28h22v6c0 1.1.9 2 2 2h27l-7-14 7-14H36z"
    ></path>
    <path
      class="heroicon-flag-stripes heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M36 11.5V10a2 2 0 0 0-2-2H6v4h22v8h27l2-4H36v-4.5zM6 32h22v4H6v-4zm22 8h27l2 4H30a2 2 0 0 1-2-2v-2z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M27 14v23h-3l3-23zm1 0a2 2 0 0 1 2-2h6v4h-6a2 2 0 0 1-2-2z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M8 3.5c0 .95-.38 1.82-1 2.45V7h27a3 3 0 0 1 3 3v5h22l-1.07 2L51 30l6.93 13L59 45H30a3 3 0 0 1-3-3v-5H7v23H2V5.95A3.49 3.49 0 0 1 4.5 0 3.5 3.5 0 0 1 8 3.5zM4.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM35 10a1 1 0 0 0-1-1H7v2h27a1 1 0 0 0 1-1zm-7.24 2H7v20h20V14c0-.77.29-1.47.76-2zM29 14a1 1 0 0 0 1 1h5v-2.17a3 3 0 0 1-1 .17h-4a1 1 0 0 0-1 1zm1 3a3 3 0 0 1-1-.17V19h25.6l1.07-2H30zM7 33v2h20v-2H7zm-2 4V6.96a3.53 3.53 0 0 1-1 0V58h1V37zm43.73-7l.5-.94L54.08 20H29v20h25.07l-4.83-9.06-.5-.94zM29 42a1 1 0 0 0 1 1h25.67l-1.07-2H29v1z"
    ></path>
  </svg>
</template>
